<template>
	<div class="page-loading">LOADING</div>
</template>

<script>
export default {
	name: 'PageLoading'
};
</script>
